// src/views/Legal/Disclaimers.js
// Avisos legales (/disclaimers, /avisos): BBTS no es procesador de pagos y
// las marcas de terceros son de sus dueños.
import React from "react";
import company from "../../config/company";

const Disclaimers = () => {
  const effectiveDate = "12 de octubre de 2026";

  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">Avisos legales</h1>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. No somos procesador de pagos</h2>
      <p className="mb-4">
        {company.legalName} ("BBTS") desarrolla software, incluida la
        aplicación {company.products.meso360}. BBTS no es un banco, un
        procesador de pagos ni un proveedor de servicios de comerciante. Los
        pagos con tarjeta los procesan Clover/Fiserv o Dejavoo/iPOSpays en sus
        propias terminales y aplicaciones. Las aprobaciones, declinaciones,
        reembolsos, contracargos, cargos por servicio, comisiones y depósitos
        se rigen por el contrato entre el comercio y su procesador.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Datos de tarjeta</h2>
      <p className="mb-4">
        {company.products.meso360} no guarda el número completo de la tarjeta,
        el código de seguridad, la fecha de vencimiento, el nombre del titular,
        los datos del chip ni los tokens de pago. Solo conserva los datos
        necesarios para cuadrar las cuentas del restaurante, como se explica en
        nuestra{" "}
        <a className="text-orange-700 underline" href="/privacidad">
          Política de Privacidad
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Marcas de terceros</h2>
      <p className="mb-4">
        Clover y Fiserv, Dejavoo, iPOSpays, DvPayLite, WhatsApp, Android y las
        demás marcas mencionadas son propiedad de sus respectivos dueños. Su
        mención indica compatibilidad o integración y no implica que esas
        empresas patrocinen o respalden a BBTS.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Impuestos y cuadres</h2>
      <p className="mb-4">
        {company.products.meso360} calcula el IVU y otros montos según la
        configuración del comercio. El comercio es responsable de revisar esa
        configuración, sus cierres de lote y sus obligaciones fiscales.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Disponibilidad</h2>
      <p className="mb-4">
        Nuestras soluciones dependen de internet, de los equipos del comercio y
        de servicios de terceros. No garantizamos que funcionen sin
        interrupciones. Los términos completos están en nuestros{" "}
        <a className="text-orange-700 underline" href="/terminos">
          Términos de Servicio
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Contacto</h2>
      <p className="mb-4">
        Escríbenos a{" "}
        <a className="text-orange-700 underline" href={`mailto:${company.email}`}>
          {company.email}
        </a>{" "}
        o visita nuestra página de{" "}
        <a className="text-orange-700 underline" href="/contact">
          soporte
        </a>
        .
      </p>

      <p className="text-sm text-gray-500 mt-8">Última actualización: {effectiveDate}</p>
    </div>
  );
};

export default Disclaimers;
